import axios from "axios"

class CommonAPI {
  getStatic = async params => {
    return axios.get(`api/static/${params}`)
  }

  getCountries = async params => {
    return axios.get("api/countries", { params })
  }

  getMeasurementsOptions = async params => {
    return axios.get("api/measurements", { params })
  }

  sharedEntities = async params => {
    return axios.post("api/shared-entities", params)
  }

  getEmails = async params => {
    return axios.get("api/emails", { params })
  }
  getDepartments = async params => {
    return axios.get("api/departments", { params })
  }
}

export const common = new CommonAPI()
